<template>
    <div class="">
        <template v-if="diagnoses.length > 0">
            <div v-for="(d, index) in diagnoses" class="card-text" :data-testid="'visit-diagnosis-' + d.id">
                <div class="d-flex justify-content-between">
                    <div class="p-0">
                        {{ d.disease.code }} - {{ d.disease.name_cs }}
                    </div>
                    <div class="p-0">
                        <i>{{ d.note }}</i>
                    </div>
                    <div class="p-0">
                        <template v-if="d.actions.length < 1">
                            <button v-if="!deleteDiagnosisPending" @click="removeDiagnosis(d.id)" class="btn btn-sm btn-danger" :data-testid="'visit-diagnosis-delete-' + d.id"><i class="fa fa-trash-o" aria-hidden="true"></i></button>
                            <button class="btn btn-danger btn-sm disabled" v-else><i class="fa fa-trash-o" aria-hidden="true"></i></button>
                        </template>
                    </div>
                </div>
                <list-actions v-on:update="updateDiagnosis" v-on:openOperationModal="openModalWithOperation" :actions="d.actions"></list-actions>

                <template v-if="(diagnoses.length - 1) === index">
                    <add-action :diagnosisListIndex="index" :focus-input="focusAddActionInput" v-on:focused="isFocused" v-on:update="updateDiagnosis" v-on:openOperationModal="openModalWithOperation" :diagnosis-id="d.id"></add-action>
                </template>
                <template v-else="">
                    <add-action :diagnosisListIndex="index" v-on:update="updateDiagnosis" v-on:openOperationModal="openModalWithOperation" :diagnosis-id="d.id"></add-action>
                </template>
                <hr class="border-primary">
            </div>
        </template>
        <div class="text-center" v-else-if="diagnosesPending">
            <i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i><br/>
            (načítám)
        </div>
        <div class="text-center" v-else="">
            <i class="fa fa-frown-o fa-3x"></i><br/>
            (žádná diagnóza nebyla přidána)
        </div>
        <operation-info :operation="selectedOperation"></operation-info>
    </div>
</template>

<script>
  import apiMixin from '@/mixins'

  import AddAction from './AddAction.vue'
  import ListActions from './ListActions.vue'
  import OperationInfo from '@/views/Visit/modals/OperationInfo.vue'

  export default {
    data () {
      return {
        reloadActions: {},
        diagnosesPending: false,
        diagnosesError: false,
        diagnosesDone: false,
        diagnoses: [],
        // Diagnosis (delete)
        deleteDiagnosisPending: false,
        deleteDiagnosisDone: false,
        deleteDiagnosisError: false,
        // operation info modal
        selectedOperation: false,
        focusAddActionInput: false
      }
    },
    props: ['doUpdate', 'focusInput'],
    components: {
      // ClientVisits,
      AddAction,
      ListActions,
      OperationInfo
    },
    mixins: [apiMixin],
    methods: {
      removeDiagnosis (id) {
        this.deleteDiagnosis(id)
      },
      updateDiagnosis () {
        this.getDiagnoses(this.$route.params.visitid)
      },
      isFocused () {
        this.$emit('focused')
      },
      openModalWithOperation (operation) {
        this.selectedOperation = operation
        this.$modal.show('operation-info')
      }
    },
    watch: {
      doUpdate (val) {
        if (val === true) {
          this.getDiagnoses(this.$route.params.visitid)
        }
      },
      deleteDiagnosisDone (val) {
        if (val === true) {
          this.getDiagnoses(this.$route.params.visitid)
          this.deleteDiagnosisDone = false
        }
      },
      '$route.params.visitid' () {
        // this.getDiagnoses(this.$route.params.visitid)
        this.getDiagnoses(this.$route.params.visitid)
      },
      diagnosesDone (val) {
        if (val === true) {
          this.$emit('updated', this.diagnoses.length)
        }
      },
      focusInput (val) {
        if (val === true) {
          this.$nextTick(function () {
            this.focusAddActionInput = true
          })
        } else {
          this.focusAddActionInput = false
        }
      }
    },
    filters: {
      str: function (text) {
        var countSpaces = 8 - text.length

        for (var i = 0; i < countSpaces; i++) {
          text += ' '
        }
        return text
      }
    },
    beforeMount () {
      this.getDiagnoses(this.$route.params.visitid)
    }

  }
</script>



// WEBPACK FOOTER //
// src/views/Visit/components/ListDiagnosis.vue?55c29abc